import React from "react";

import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { FlatButton } from "src/framework/components/buttons";

import { IConfirmationDialog, openDialogConfirmation$, setupDialog$ } from "src/framework/store";
import { useObservable } from "src/framework/store/storeUtil";


const Confirmation = () => {
  const open = useObservable<boolean>(openDialogConfirmation$);
  const setup = useObservable<IConfirmationDialog>(setupDialog$)


  return (
    <div>
      <Dialog
        open={open || false}
        onClose={() => {
          setup?.onClose();
        }}
      >
        <DialogTitle id="simple-dialog-title">
          {setup?.title}
        </DialogTitle>
        <DialogContent
          style={{
            minWidth: setup?.size || "300px",
          }}
        >
          <DialogContentText id="alert-dialog-description">
            {setup?.content}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <FlatButton
            onClick={() => {
              if (setup?.onNegation) {
                setup?.onNegation();
              }
              setup?.onClose();
            }}
            color="secondary"
            text={setup?.noText || "Não"}
          />
          <FlatButton
            onClick={() => {
              if (setup?.onConfirmation) {
                setup?.onConfirmation();
              }
              setup?.onClose();
            }}
            color="primary"
            variant="contained"
            text={setup?.yesText || "Sim"}
          />
        </DialogActions>
      </Dialog>
    </div>
  );
};

export { Confirmation };
